/**
 * Flow Optimizer feature flags
 * For Media Devoted | Created By Ciro Autiero
 *
 * The typed Standard tab (paths, conditional groups, Voluum apply) is the
 * default everywhere. Set `VITE_VOLUUM_STANDARD_V2=false` only for an
 * emergency fallback to the legacy JSON textarea.
 */

const TRUTHY = new Set(['1', 'true', 'on', 'yes']);

function readFlag(name: string, fallback = false): boolean {
  const raw = import.meta.env[name as keyof ImportMetaEnv];
  if (raw == null) return fallback;
  return TRUTHY.has(String(raw).trim().toLowerCase());
}

/** Typed Standard tab + Voluum-direct apply — default ON; opt out via env. */
export const VOLUUM_STANDARD_V2 = readFlag('VITE_VOLUUM_STANDARD_V2', true);
